import React from 'react';
import './disclaimer.scss';

const Disclaimer = (props) => {
  const disclaimerOpen = props.disclaimerOpen;
  const openDisclaimer = props.openDisclaimer;

  return (
    <div className="disclaimer">
      <ul className={`disclaimer mdn-Text mdn-Text--caption ${disclaimerOpen ? `is-open` : ``}`}>
        <li>
          <strong>1.</strong> Os Canais Abertos Obrigatórios Gratuitos são disponibilizados conforme previsto na Lei
          12.485/11, ou seja, de forma gratuita, portanto, não integram o preço da mensalidade do serviço contratado e
          podem ser excluídos da grade de programação a qualquer momento, mediante comunicado aos clientes.
        </li>
        <li>
          <strong>2.</strong> Todos os Canais Cortesia são disponibilizados por liberalidade da NET, portanto, não
          integram o preço da mensalidade do serviço contratado e podem ser excluídos da grade de programação a qualquer
          momento, mediante comunicado aos clientes.
        </li>
        <li>
          <strong>3.</strong> Canal transmitido em Alta Definição - HD. Seu conteúdo é idêntico ao transmitido em
          Digital SD.
        </li>
        <li>
          <strong>4.</strong> Curta!, Woohoo, Arte 1, Prime Box Brazil, Music Box Brazil e Play TV são canais
          brasileiros de espaço qualificado. Caso estes canais deixem de atender às exigências previstas na Lei
          12.485/11 e/ou em quaisquer outros regulamentos existentes a respeito do tema, poderão ser excluídos da grade
          de programação da NET.
        </li>
        <li>
          <strong>5.</strong> O serviço NOW é compatível com os produtos de alta definição desde que a região esteja
          apta a recebê-lo. O Telecine Play é um canal exclusivo para clientes HD que possuam os canais Telecines em HD
          e NOW. Consulte disponibilidade técnica do serviço em sua região/endereço.
        </li>
        <li>
          <strong>6.</strong> Consulte disponibilidade dos canais no seu pacote.
        </li>
      </ul>
      <div className="continue-lendo">
        <div className="mdn-Link mdn-Link--arrow">
          <button className="mdn-Link-anchor" onClick={openDisclaimer}>
            {disclaimerOpen ? `Ler menos` : `Continue lendo`}
            <i
              className={`mdn-Link-anchor-icon ${disclaimerOpen ? `mdn-Icon-cima` : `mdn-Icon-baixo`} mdn-Icon--md`}
            ></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
